import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Abouts from '@/views/Abouts'
import News from '@/views/News'
import Products from '@/views/Products'
import Contact from '@/views/Contact'
import NewsDetail from '@/views/NewsDetail'
import ProdDetail from '@/views/ProdDetail'


Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/abouts',
      name: 'Abouts',
      component: Abouts
    },
    {
      path: '/News',
      name: 'News',
      component: News
    },
    {
      path: '/Products',
      name: 'Products',
      component: Products
    },
    {
      path: '/Contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/newsDetail/:id',
      name: 'newsDetail',
      component: NewsDetail
    },
    {
      path: '/prodDetail/:id',
      name: 'prodDetail',
      component: ProdDetail
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
}
)



// WEBPACK FOOTER //
// ./src/router/index.js